import { UseAxiosResult } from "axios-hooks";

import api from "config/urls/api";

import formatUrl from "../utils/formatUrl";
import { UseSelectUserManagementApi } from "./setup";

export type ClientImageUrls = {
  logoUrl: string;
};

export const useClientImageUrlsQuery = (
  clientId: string
): UseAxiosResult<ClientImageUrls> => {
  return UseSelectUserManagementApi<ClientImageUrls>(
    {
      url: formatUrl(api.clientImages, { clientId }),
      method: "GET",
    },
    {
      manual: true,
    }
  );
};
